import {getRouterLocationQuery, statusContainer, utils} from '@wallaby-ui/core';
import {LIBRARY_NAME} from 'src/js/common/constants';
import {filterAndSearchSlice} from 'src/js/containers/filter_and_search/filter_and_search_slice';
import {changeQueryParams} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import HierarchyFetcher from 'src/js/fetchers/hierarchy_fetcher';
import {HierarchyTypes} from 'src/js/model/hierarchy';

import * as at from './hierarchy_action_types';

const logger = utils.LogUtils.getLogger('HierarchyActions', LIBRARY_NAME);

export function resetReload(stateId) {
  return (dispatch) =>
    dispatch({type: at.RESET_RELOAD, payload: false, stateId});
}

export function selectorResetReload(stateId) {
  return (dispatch) =>
    dispatch({type: at.SELECTOR_RESET_RELOAD, payload: false, stateId});
}

export function loadStateFromParams(stateId, filterAndSearchStateId) {
  return (dispatch, getState) => {
    const state = getState();
    const {parentHierarchyId} = getRouterLocationQuery(state);

    return Promise.all([
      dispatch(changeQueryParams(filterAndSearchStateId, {parentHierarchyId})),
      dispatch(
        filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
          parentHierarchy: false,
        })
      ),
    ]).then(() =>
      Promise.all([
        dispatch({type: at.LOCATION_PARSED, payload: true, stateId}),
        dispatch(resetReload(stateId)),
      ]).then(() =>
        dispatch(
          filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
            parentHierarchy: true,
          })
        )
      )
    );
  };
}

export function loadStateFromParamsSelector(stateId, filterAndSearchStateId) {
  return (dispatch, getState) => {
    const state = getState();
    let {hierarchyId} = getRouterLocationQuery(state);

    if (
      !hierarchyId &&
      state[stateId].hierarchyTypes.getItems() &&
      state[stateId].hierarchyTypes.getItems().length > 0
    ) {
      // if hierarchy id is not set, set the first hierarchy type
      hierarchyId = state[stateId].hierarchyTypes
        .getItems()[0]
        .getOptionsProjection().value;
    } else {
      hierarchyId = hierarchyId || null;
    }

    return Promise.all([
      dispatch(changeQueryParams(filterAndSearchStateId, {hierarchyId})),
      dispatch(
        filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
          hierarchy: false,
        })
      ),
    ]).then(() =>
      Promise.all([
        dispatch({type: at.SELECTOR_LOCATION_PARSED, payload: true, stateId}),
        dispatch(selectorResetReload(stateId)),
      ]).then(() =>
        dispatch(
          filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
            hierarchy: true,
          })
        )
      )
    );
  };
}

export function getHierarchyTypes(requestUrl, stateId, filterAndSearchStateId) {
  return (dispatch) =>
    HierarchyFetcher.getHierarchyTypes(requestUrl)
      .then((response) => {
        const hierarchyTypes = new HierarchyTypes(response);
        dispatch({
          type: at.HIERARCHY_TYPES_FETCH_SUCCESS,
          payload: hierarchyTypes,
          stateId,
        });
      })
      .catch((error) => {
        logger.error(`HIERARCHY_TYPES_FETCH_FAILURE: ${error}`);
        dispatch(
          statusContainer.addError(error, at.HIERARCHY_TYPES_FETCH_FAILURE)
        );
        dispatch({
          type: at.HIERARCHY_TYPES_FETCH_FAILURE,
          payload: error,
          stateId,
        });
      })
      .then(() =>
        dispatch(loadStateFromParamsSelector(stateId, filterAndSearchStateId))
      );
}
